export default __webpack_public_path__ + "static/media/icmp.e2af77e2.svg";